import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2Icon, XCircleIcon } from 'lucide-react';
const listVariants = {
  hidden: {
    opacity: 0
  },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    x: -20
  },
  show: {
    opacity: 1,
    x: 0
  }
};
export function FeaturesSection() {
  const features = ['60 páginas prácticas con prompts listos', '6 capítulos: Organización Personal, Estudio, Trabajo, Creatividad, Vida Personal y Automatización', 'Ejemplos de la vida real en cada área', 'Consejos para personalizar cada prompt a tu medida', 'Mini casos prácticos que muestran resultados reales', 'Flujos simples para integrar ChatGPT con tus herramientas favoritas'];
  const forWho = ['Profesionales con poco tiempo', 'Emprendedores que quieren automatizar sus tareas', 'Estudiantes que buscan organizar su aprendizaje', 'Creadores de contenido que necesitan ideas constantes', 'Cualquiera que quiera optimizar su vida diaria con IA'];
  const notForWho = ['Personas que no están dispuestas a probar nuevas herramientas', 'Quienes buscan una guía teórica sin ejemplos prácticos', 'Los que no se sienten cómodos experimentando con IA', 'Aquellos que prefieren métodos tradicionales sin tecnología'];
  return <section id="que-incluye" className="py-24 px-6 bg-navy-800 relative" data-id="element-26">
      <div className="max-w-5xl mx-auto" data-id="element-27">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-28">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-29">
            Qué incluye tu guía
          </h2>
          <div className="w-24 h-1 bg-cyan-neon mx-auto rounded-full" data-id="element-30"></div>
        </motion.div>

        {/* Features List */}
        <motion.div variants={listVariants} initial="hidden" whileInView="show" viewport={{
        once: true
      }} className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-20" data-id="element-31">
          {features.map((feature, i) => <motion.div key={i} variants={itemVariants} className="bg-navy-900/50 border border-cyan-neon/10 rounded-xl p-5 flex items-start gap-4 hover:border-cyan-neon/30 transition-colors" data-id="element-32">
              <CheckCircle2Icon className="w-6 h-6 text-green-400 shrink-0 mt-0.5" data-id="element-33" />
              <span className="text-slate-200 font-medium" data-id="element-34">{feature}</span>
            </motion.div>)}
        </motion.div>

        {/* Audience Split */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-35">
          {/* For Who */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-green-cta/5 border border-green-cta/20 rounded-2xl p-8" data-id="element-36">
            <h3 className="text-2xl font-bold text-green-400 mb-6 flex items-center gap-3" data-id="element-37">
              <CheckCircle2Icon className="w-7 h-7" data-id="element-38" />
              Para quién es
            </h3>
            <ul className="space-y-4" data-id="element-39">
              {forWho.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-40">
                  <span className="text-green-400 mt-1" data-id="element-41">✓</span>
                  <span className="text-slate-300" data-id="element-42">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* Not For Who */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-red-500/5 border border-red-500/20 rounded-2xl p-8" data-id="element-43">
            <h3 className="text-2xl font-bold text-red-400 mb-6 flex items-center gap-3" data-id="element-44">
              <XCircleIcon className="w-7 h-7" data-id="element-45" />
              Para quién NO es
            </h3>
            <ul className="space-y-4" data-id="element-46">
              {notForWho.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-47">
                  <span className="text-red-500 mt-1" data-id="element-48">✕</span>
                  <span className="text-slate-300" data-id="element-49">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}